import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

export const HOMEOWNER_HUBS = 'bb46db80-c1dc-42a4-8871-8baa78d0d653';
export const MOVE_HUBS = '6d6761cc-1362-481c-930a-09bf9c29462b';
export const ACTIVITY_HISTORY_ALERTS = '3ee3a6b0-0545-42f1-99bc-53cd245cfaa2';
export const BRANDED_COMMUNICATIONS = '2a55ac67-7839-47af-8f54-c99d55c572e4';
export const PURCHASE_HUBS = '68df1896-f24c-4e37-a820-38d146ae4786';
export const SALE_HUBS = 'e5798750-f3e7-43dd-a6ba-d134089c6ded';
export const BRANDED_HUBS = 'f4773e2a-c4c6-4593-9186-7ce0905692e6';
export const SUPPORT_TRAINING_BY_HUMANS = '92d799ed-9013-4f43-86cc-8e52820db590';
export const PRIVATE_DOMAIN_NAME = '85be52b5-0ad0-4c47-931d-604ce00b61f9';
export const CUSTOMIZED_COMMUNICATIONS = 'aaacfdad-ecd6-4f0a-b156-4b7157ecdc91';
export const INVITATIONS = 'e25a737d-0152-426f-accc-843756b3ba0e';
export const ENGAGEMENT_DATA = '6ab06035-2eb7-45fb-a6eb-18397dfee8c4';
export const BRANDED_EMAILS = '9c9afa59-66ac-4f22-8ed2-e4cbbd83ab78';
export const ACTIVITY_EMAILS = 'd7ca556f-f7a1-45f0-9b3b-0cf5a4ec800c';
export const LANDING_PAGES = '5cefe053-60ae-44b2-a193-a484d8e23edb';
export const OPPORTUNITIES = '3ec1fd1a-6f7b-4ecd-91a7-36cf5d626f19';

class LuSubscriptionPlanFeatureAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'lu-subscription-plan-feature';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'lus/subscriptions/plans/features';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'title',
      'slug',
      'description',
      'order',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return [
    ];
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return [
    ];
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      title: {
        type: 'string',
        presence: true,
        length: {
          maximum: 255,
        },
      },
      slug: {
        type: 'string',
        presence: true,
        length: {
          maximum: 255,
        },
      },
      description: {
        type: 'string',
        length: {
          maximum: 255,
        },
      },
      order: {
        type: 'string',
        presence: true,
      },
    };
  }

}

export default LuSubscriptionPlanFeatureAppResource;
